<template>
  <div class="wrapper">
    <el-row>
      <el-col :span="8">
        <BuscaRedeDescredenciada
          @descredenciados="setDescredenciados"
          @emptyList="emptyList"
        />
      </el-col>
      <el-col :span="16">
        <div class="listagem-wrapper">
          <ListaDescredenciados
            v-if="descredenciados && !semDescredenciados"
            :descredenciados="descredenciados.lista"
            :total="descredenciados.quantidade"
            @changeFilters="changeFilters"
          />
          <RedeDescredenciadaEmpty v-else :semDescredenciados="semDescredenciados" />
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import RedeDescredenciadaEmpty from './RedeDescredenciadaEmpty.vue'
import ListaDescredenciados from './ListaDescredenciados.vue'
import BuscaRedeDescredenciada from './BuscaRedeDescredenciada.vue'
import moment from 'moment/moment'
import { formatAddress } from '../../utils/utils'

export default {
  name: 'RedeDescredenciada',
  components: { BuscaRedeDescredenciada, ListaDescredenciados, RedeDescredenciadaEmpty },
  data: () => ({
    todosDescredenciados: null,
    descredenciados: null,
    semDescredenciados: false
  }),
  methods: {
    emptyList () {
      this.semDescredenciados = true
    },
    async setDescredenciados (descredenciados) {
      this.todosDescredenciados = descredenciados
      this.descredenciados = this.handleDescredenciados(descredenciados)
    },
    changeFilters ({ tipo }) {
      if (!this.todosDescredenciados || this.todosDescredenciados.lista) {
        this.descredenciados = null
      }

      switch (tipo) {
        case 'descredenciados': {
          const lista = Object.assign([], this.todosDescredenciados.lista).filter((item) => {
            return item.substituto === null
          })
          this.descredenciados = this.handleDescredenciado({ ...this.todosDescredenciados, lista })
          this.descredenciados.quantidade = lista.length
        }
          break
        case 'substituidos': {
          const lista = Object.assign([], this.todosDescredenciados.lista).filter((item) => {
            return item.substituto !== null
          })
          this.descredenciados = this.handleDescredenciado({ ...this.todosDescredenciados, lista })
          this.descredenciados.quantidade = lista.length
        }
          break
        default:
          this.descredenciados = this.handleDescredenciados(this.todosDescredenciados)
          break
      }
    },
    handleDescredenciados (descredenciados) {
      if (!descredenciados || !descredenciados.lista) return null

      descredenciados.lista = Object.assign([], descredenciados.lista).map((item) => {
        const newItem = { ...item }
        if (newItem.bloqueado) {
          newItem.bloqueado = this.handleDescredenciado({ ...newItem.bloqueado })
        }

        if (newItem.substituto) {
          newItem.substituto = this.handleDescredenciado({ ...newItem.substituto })
        }
        return newItem
      })

      return descredenciados
    },
    handleDescredenciado (descredenciado) {
      descredenciado.data_inicio_atendimento = this.formatDate(descredenciado.data_inicio_atendimento)
      descredenciado.data_bloqueio = this.formatDate(descredenciado.data_bloqueio)

      descredenciado.enderecoCompleto = formatAddress({
        street: descredenciado.endereco,
        number: descredenciado.numero,
        complement: descredenciado.complemento,
        city: descredenciado.nome_cidade,
        state: descredenciado.id_estado,
        district: descredenciado.bairro
      })

      return descredenciado
    },
    formatDate (stringDate) {
      if (!stringDate) {
        return null
      }

      const date = moment(stringDate.split('T').shift()).locale('pt-br')

      if (!date.isValid()) {
        return null
      }

      return date.format('DD/MM/YYYY')
    }
  }
}
</script>

<style scoped>
.wrapper {
  width: 100%;
}
.listagem-wrapper {
  flex: 1;
  height: 100%;
  overflow: auto;
  border-left: 1px solid #EEEEEE;
  width: 100%;
}
</style>
